var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"z-index":"9999","show":_vm.show}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }